export const Karte = [
	['AA', false],
	['KK', false],
	['QQ', false],
	['JJ', false],
	['AKs', false],
	['TT', false],
	['AQs', false],
	['AJs', false],
	['KQs', false],
	['AK', false],
	['99', false],
	['JTs', false],
	['QJs', false],
	['KJs', false],
	['ATs', false],
	['AQ', false],
	['T9s', true],
	['KQ', false],
	['88', false],
	['QTs', false],
	['98s', true],
	['J9s', true],
	['AJ', false],
	['KTs', false],
	['77', false],
	['87s', false],
	['Q9s', true],
	['T8s', true],
	['KJ', true],
	['QJ', true],
	['JT', true],
	['76s', false],
	['97s', true],
	['A2s', false],
	['A3s', false],
	['A4s', false],
	['A5s', false],
	['A6s', false],
	['A7s', false],
	['A8s', false],
	['A9s', false],
	['65s', true],
	['66', false],
	['AT', true],
	['86s', true],
	['KT', true],
	['QT', true],
	['54s', true],
	['K9s', true],
	['J8s', true],
	['55', false],
	['44', false],
	['33', false],
	['22', false],
];

export function getColorPokers(id) {
	//               par, dvapara,   set,   skala, boja,    full,    poker, skalapoker
	const colors = ['gold', 'maroon', 'blue', 'red', 'lime', 'magenta', 'red', 'black'];
	return colors[id];
}

export const KarteDrugihIgraca = [
	['AA', false],
	['KK', false],
	['QQ', false],
	['JJ', false],
	['AKs', false],
	['TT', false],
	['AQs', false],
	['AJs', false],
	['KQs', false],
	['AK', false],
	['99', false],
	['JTs', false],
	['QJs', false],
	['KJs', false],
	['ATs', false],
	['AQ', false],
	['T9s', false],
	['KQ', false],
	['88', false],
	['QTs', false],
	['98s', false],
	['J9s', false],
	['AJ', false],
	['KTs', false],
	['77', false],
	['87s', false],
	['Q9s', false],
	['T8s', false],
	['KJ', false],
	['QJ', false],
	['JT', false],
	['76s', false],
	['97s', false],
	['A2', false],
	['A3', false],
	['A4', false],
	['A5', false],
	['A6', false],
	['A7', false],
	['A8', false],
	['A9', false],
	['A2s', false],
	['A3s', false],
	['A4s', false],
	['A5s', false],
	['A6s', false],
	['A7s', false],
	['A8s', false],
	['A9s', false],
	['65s', false],
	['66', false],
	['AT', false],
	['86s', false],
	['KT', false],
	['QT', false],
	['54s', false],
	['K9s', false],
	['J8s', false],
	['55', false],
	['44', false],
	['33', false],
	['22', false],
];

export const pokusKarte = [
	{ name: 'AA', value: false },
	{ name: 'KK', value: false },
	{ name: 'QQ', value: false },
	{ name: 'JJ', value: false },
	{ name: 'AKs', value: false },
	{ name: 'TT', value: false },
	{ name: 'AQs', value: false },
	{ name: 'AJs', value: false },
	{ name: 'KQs', value: false },
	{ name: 'AK', value: false },
	{ name: '99', value: false },
	{ name: 'JTs', value: false },
	{ name: 'QJs', value: false },
	{ name: 'KJs', value: false },
	{ name: 'ATs', value: false },
	{ name: 'AQ', value: false },
	{ name: 'T9s', value: false },
	{ name: 'KQ', value: false },
	{ name: '88', value: false },
	{ name: 'QTs', value: false },
	{ name: '98s', value: false },
	{ name: 'J9s', value: false },
	{ name: 'AJ', value: false },
	{ name: 'KTs', value: false },
	{ name: '77', value: false },
	{ name: '87s', value: false },
	{ name: '56s', value: false },
	{ name: '76s', value: false },
	{ name: '89s', value: false },
	{ name: '66', value: false },
	{ name: 'A2s', value: false },
	{ name: 'A3s', value: false },
	{ name: 'A4s', value: false },
	{ name: 'A5s', value: false },
	{ name: 'A6s', value: false },
	{ name: 'A7s', value: false },
	{ name: 'A8s', value: false },
	{ name: 'A9s', value: false },
	{ name: '55', value: false },
	{ name: '44', value: false },
	{ name: '33', value: false },
	{ name: '22', value: false },
];

export const FullDeck = [
	'2S',
	'2H',
	'2D',
	'2C',
	'3S',
	'3H',
	'3D',
	'3C',
	'4S',
	'4H',
	'4D',
	'4C',
	'5S',
	'5H',
	'5D',
	'5C',
	'6S',
	'6H',
	'6D',
	'6C',
	'7S',
	'7H',
	'7D',
	'7C',
	'8S',
	'8H',
	'8D',
	'8C',
	'9S',
	'9H',
	'9D',
	'9C',
	'TS',
	'TH',
	'TD',
	'TC',
	'JS',
	'JH',
	'JD',
	'JC',
	'QS',
	'QH',
	'QD',
	'QC',
	'KS',
	'KH',
	'KD',
	'KC',
	'AS',
	'AH',
	'AD',
	'AC',
];
